<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('充值.充值')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px; height: 15px;" />
      </template>
    </van-nav-bar>

    <van-cell-group>
      <van-field
        v-model="money"
        type="number"
        :placeholder="$t('充值.请输入充值金额')"
      />
    </van-cell-group>

    <div class="p_c">
      <span>{{ $t('充值.余额') }}</span>
      <span class="number">{{ balance }}{{ $t('充值.个') }}</span>
    </div>

    <!-- 快速选择金额 -->
    <div class="quick-section">
      <div class="quick-title">{{ $t('充值.快速选择金额') }}</div>
      <div class="quick-grid">
        <div
          v-for="amount in quickAmounts"
          :key="amount"
          class="quick-btn"
          :class="{ active: money == amount }"
          @click="selectAmount(amount)"
        >
          {{ amount }}
        </div>
      </div>
    </div>

    <div class="sub-btn" @click="onSubmit">
      {{ $t('充值.确认') }}
    </div>

    <div class="shuoming">
      <div class="l_p q1">{{ $t('充值.提示') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargePage',

  data() {
    return {
      balance: '0.00',
      money: '',
      pay_way: 'Mexicopay',
      quickAmounts: [50, 100, 200, 500, 1000, 3000, 5000, 10000, 30000],
    }
  },

  mounted() {
    if (this.$route.params.balance) {
      this.balance = this.$route.params.balance
    } else {
      this.getUserBalance()
    }
  },

  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    selectAmount(amount) {
      this.money = amount
    },

    getUserBalance() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.balance = res.data.balance
        }
      }).catch(() => {})
    },

    onSubmit() {
      const money = parseFloat(this.money)
      if (!money || money <= 0) {
        this.$toast(this.$t('充值.金额错误'))
        return
      }
      this.$router.push('/ServiceOnline')
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.p_c {
  color: #fff;
  padding: 0 30px 20px;
  font-size: 28px;

  .number {
    color: #f3c7a2;
    font-weight: bold;
  }
}

.quick-section {
  padding: 0 30px 20px;
}

.quick-title {
  color: #c5a081;
  font-size: 28px;
  margin-bottom: 20px;
  border-left: 6px solid #c5a081;
  padding-left: 16px;
}

.quick-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.quick-btn {
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 10px;
  color: #f3c7a2;
  font-size: 28px;
  font-weight: 500;
  padding: 16px 0;
  width: calc(33.33% - 12px);
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.96);
  }

  &.active {
    background: linear-gradient(#fde3ca, #e7b486);
    border-color: #e7b486;
    color: #68302c;
    font-weight: bold;
  }
}

// ── 提交按钮 ──────────────────────────────────────────
.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);
  display: block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  transition: all 0.2s ease;

  &:active {
    opacity: 0.85;
    transform: scale(0.98);
  }
}

// ── 说明 ──────────────────────────────────────────────
.shuoming {
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;

  .l_p {
    font-size: 26px;
    margin-top: 16px;

    &.q1 {
      font-size: 30px;
      color: #f3c7a2;
    }
  }
}

// ── Van 组件覆盖（与 Withdraw 一致） ──────────────────
/deep/ .van-field__label {
  color: #ccc;
}

.van-cell-group {
  background-color: transparent;
  padding: 30px 0;

  &:after {
    display: none;
  }
}

.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;

  & + .van-cell {
    margin-top: 30px;
  }

  /deep/ .van-field__control {
    color: #f3c7a2;
  }

  &:after {
    display: none;
  }
}
</style>
